module.exports = __webpack_public_path__ + "static/media/zinzya.7a65bfaa.png";